import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from '../../../shared/toast/toast';
import {IdexService} from '../../../idex.service';
import {DateAdapter} from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import {Mimetype} from '../../../shared/mimetype';

declare var $: any;

@Component({
  selector: 'app-upload-new-version',
  templateUrl: './upload-new-version.component.html',
  styleUrls: ['./upload-new-version.component.css']
})
export class UploadNewVersionComponent implements OnInit {
   @Input() typeName: string;
   @Input() link = '';
   @Input() idFolderExport: string;
   @Input() show = true;
   public doclist = {
      docId: '',
      docName: '',
      totalPages: '',
      signItems: []
   };

   public docNew: string[] = [];
   public files = [];
   public taskName;
   public taskId = 0;
   public template;
   public dueDate;
   public priority;
   public documents: any;
   public isDocList = false;
   public backupIdFolderExport;
   public backupPathExport;
   private path: string;
   private subscriber: Subscription;
   fileName = '';
   error: string;
   errorMessage: any;
   mimetype = [];
   object_file: any;
   items: any[];
   info: any;
   watermark: any;
   typeFile = '';
   showInclude = true;
   includeAnno: any;
   dataChecked = '1';
   file: any;
   item: any;
   limit: any;
   selectedItems: any[] = [];
   page: any;
   checkAnno: any;
   annotationId: any;
   annotationVersion: any;
   checkAnnotation: any;
   minorVersion: any;
   majorVersion: any;
   readonly size = 5242880;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private translate: TranslateService,
              public toast: Toast,
              public service: IdexService,
              private dateAdapter: DateAdapter<any>,
              private route: ActivatedRoute) { }

   ngOnInit() {
      if (this.typeName === 'startFlow') {
         this.mimetype.push({type: 'application/pdf', size: 0});
      }
      this.docNew = [];
      this.translate.get('langCurrent').subscribe((msg) => {
         if (msg === 'th') {
            this.dateAdapter.setLocale('th');
         } else {
            this.dateAdapter.setLocale('en');
         }
      });
      this.subscriber = this.route.url.subscribe(url => {
         this.path = decodeURIComponent(url.join('/'));
      });
      this.backupIdFolderExport = this.idFolderExport;
      this.backupPathExport = this.link;
      this.getWatermark();
      this.getAnnotations();
      this.minorVersion = '(' + (this.CreateMinorVersion(this.data.item.version)).toLocaleString() + ')';
      this.majorVersion = '(' + (this.ConvertStringToNumberInt(this.data.item.version) + 1).toLocaleString(undefined, {minimumFractionDigits: 1}) + ')';
   }

    CreateMinorVersion(input: string) {
       const num = input.split('.');
       const numeric = Number(num[1]) + 1;
       const mergeNumber = num[0] + '.' + numeric;
       return mergeNumber;
   }

   ConvertStringToNumberInt(input: string) {
      const num = input.split('.');
      const numeric = Number(num[0]);
      return numeric;
   }

   getWatermark() {
      this.service.getWatermark('PDFTron').subscribe((data) => {
         this.watermark = data;
      });
   }

   getAnnotations() {
      this.service.getAnnotation(this.data.item.id, true).subscribe( anno => {
         this.checkAnnotation = anno;
         if (anno != null) {
            this.checkAnno = anno;
            this.annotationVersion = anno.annotationVersion;
            this.annotationId = anno.annotationId;
            this.showInclude = true;
         } else {
            this.showInclude = false;
         }
      });
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items) {
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               hasFiles = true;
               break;
            }
         }
      } else if (data.files && data.files.length > 0) {
         hasFiles = data.files && data.files.length > 0;
      }

      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
         $('#divUpload').addClass('drag-over');
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      $('#divUpload').removeClass('drag-over');
      const data = event.dataTransfer;
      let files;
      if (data.items) {
         files = [];
         for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].kind === 'file') {
               files.push(data.items[i].getAsFile());
            }
         }
      } else {
         files = data.files;
      }
      if (files.length > 1) {
         this.handleToastError('uploadDoc.errorSelectFile');
      } else {
         this.file = data.files;
         this.fileName = files[0].name;
         this.checkMimeTypeFile(files[0].type, files[0].size);
      }
   }

   onDragLeave() {
      $('#divUpload').removeClass('drag-over');
   }

   onSelectFiles(input: any) {
      if (input.files.length === 0) {
         return;
      }
      const files = input.files;
      this.file = files;
      this.fileName = files[0].name;
      this.typeFile = files[0].type;
      this.checkMimeTypeFile(this.typeFile, files[0].size);

   }
   checkMimeTypeFile(typeFile: string, sizeFile: any) {
      const checkMime = Mimetype.checkMimeType(typeFile);
      if ((checkMime === 'doc' || checkMime === 'img') && (sizeFile <= this.size)) {
         if (this.checkAnnotation !== null) {
            this.showInclude = true;
         } else {
            this.showInclude = false;
            this.includeAnno = false;
         }
      } else {
         this.showInclude = false;
         this.includeAnno = false;
      }
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }


   onSubmit() {
      if (this.fileName !== '') {
         if (this.includeAnno === undefined) {
            this.includeAnno = false;
         }
         const annotationObj = {
            docId: this.data.item.id,
            annotationId: this.annotationId,
            annotationVersion: this.annotationVersion,
            checkAnno: this.includeAnno
         };
         if (this.dataChecked !== undefined) {
            if (this.dataChecked === '1') {
               this.data.uploadNewVersion.emit({file: this.file, item: this.data.item, isMajor: false, annotationObj: annotationObj});
            }
            if (this.dataChecked === '2') {
               this.data.uploadNewVersion.emit({file: this.file, item: this.data.item, isMajor: true, annotationObj: annotationObj});
            }
         }
      } else {
         this.translate.get('please-select-file').subscribe( s => {
            this.toast.warn(s);
         });
      }
   }
}
